import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";

export type Welder = {
  welderId: string;
  name: string;
  badgeNumber: string;
  stampNumber: string;
  companyName: string;
  divisionName: string;
  picture: string;
};

export type WelderSearch = {
  welderName?: string;
  welderId?: string;
  stampNumber?: string;
};

export function getQualifierWelderProfiles() {
  return api.get<Welder[]>("welders/qualifier");
}

export function getCoordinatorWelderProfiles() {
  return api.get<Welder[]>("welders/coordinator");
}

export function getWelders(skip: number, take: number, filters: Partial<WelderSearch>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<Welder[]>(`welders?skip=${skip}&take=${take}&${params.toString()}`);
}
